import styled from 'styled-components'
import FilledSelectContainer from './filled-select-container'

export const FilledSelectStyle = styled(FilledSelectContainer)`
  min-width: 272px;
`
